<template>
  <div class="myfooter"></div>
</template>

<script>
export default {
  name: 'myfooter'
};
</script>